import React from "react";
import "../../assets/scss/components/_complimentaryservices.scss";

import ico from "../../assets/img/our-packages/icons/baby-dress.png";

const ComplimentaryServices = ({ services = [] }) => {
  return (
    <section className="complimentary">
      <div className="complimentary__container">
        <h3>Complimentary Services</h3>

        <div className="complimentary__grid">
          {services.map((service, index) => (
            <div className="complimentary__item" key={index}>
              <img
                // src="/assets/img/our-packages/icons/baby-dress.png"
                src={require(`../../assets/img${service.image}`)}
                alt={service.alt || service.title}
              />

              <p>{service.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplimentaryServices;
